import { render, staticRenderFns } from "./InsuranceErrorLabel.vue?vue&type=template&id=396e789a&scoped=true&"
import script from "./InsuranceErrorLabel.vue?vue&type=script&lang=js&"
export * from "./InsuranceErrorLabel.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceErrorLabel.vue?vue&type=style&index=0&id=396e789a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e789a",
  null
  
)

export default component.exports